import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { MissingFieldMessages, normalizeFieldPath } from "../../../forms/missing-fields/MissingFieldsContext";
import { AssetInventoryCompletenessSection } from "../../api/ClientFileApi";
import { DescribeMissingField } from "../utils/missingFields.utils";
import { useAssetInventoryCompleteness } from "./useAssetInventoryCompleteness";

export function useMissingFieldMessages<TValues>(
  clientId: string,
  section: AssetInventoryCompletenessSection,
  values: TValues,
  describe: DescribeMissingField<TValues>
): MissingFieldMessages {
  const { t } = useTranslation();
  const { data } = useAssetInventoryCompleteness(clientId);

  return useMemo(() => {
    const messages = new Map<string, string | undefined>();
    const missingFields = data?.sections.find((s) => s.section === section)?.missingFields ?? [];

    for (const field of missingFields) {
      const described = describe(field, values, t);
      if (described) {
        messages.set(normalizeFieldPath(described.path), described.message);
      }
    }

    return messages;
  }, [data, section, values, describe, t]);
}
